import React from "react";

export function WorkspaceInlineLoader({ label = "Loading", compact = false }) {
  return (
    <span className={`workspace-inline-loader${compact ? " is-compact" : ""}`} role="status">
      <i aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
